<template>
  <div class="block-sale">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <BimSteps color="luxury" :slides="slides">
          <template v-slot:steps_header>
            <div>
              <bim-text type=h4 bold class="steps__title">Для тех, <br />кто привык брать<br /><span class="luxury-color">максимум</span></bim-text>
              <img alt="" :src="`${imgPath}/landing-plans-2-6.svg`" />
              <bim-text type=accent bold class="mb-9 mt-10">Приоритетное размещение вашего бренда</bim-text>
              <bim-text type=main class="mb-9">Поможем выделиться среди конкурентов, повысим узнаваемость вашей торговой марки.</bim-text>
            </div>
          </template>
        </BimSteps>

        <bim-text type=main bold class="block-sale__more mb-10 mt-11">и еще</bim-text>

        <div class="advantages d-flex mb-9 mb-md-12">
          <div
            v-for="advantage of advantages"
            :key="advantage.title"
            class="advantages__item"
          >
            <img alt="" :src="advantage.img" class="advantages__img mr-9" />
            <bim-text type=main bold class="advantages__title">{{ advantage.title }}</bim-text>
          </div>
        </div>

        <div class="tariff d-flex align-center flex-column flex-md-row">
          <div class="d-flex align-end">
            <div class="tariff-price__wrapper">
              <div class="d-flex align-end">
                <bim-text type=accent class="pb-2 pr-4" bold>от</bim-text>
                <bim-text type=main class="tariff-price__number">180 000</bim-text>
                <bim-text type=accent bold class="tariff-price__symbol pl-2 pb-3">₽</bim-text>
              </div>
              <bim-text type=main bold>за год</bim-text>
            </div>
          </div>

          <ButtonLeaveRequest color=luxury class="ml-md-9 mr-md-10 mt-9 mt-md-0 mb-10 mb-md-0" @click="$emit('leaveRequest', 'Запрос на подключение тарифа Максимум')" />
        </div>
        <div class="tariff__delimiter"></div>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import ButtonLeaveRequest from "./ButtonLeaveRequest"
import BimSteps from "@/components/BimSteps"
import bimCol from "@bimlib/components/bimCol"
import bimContainer from "@bimlib/components/bimContainer"
export default {
  inject: ["imgPath"],
  name: "",
  components: {
    ButtonLeaveRequest,
    BimSteps,
    bimCol,
    bimContainer,
  },
  data() {
    return {
      slides: [
        {
          img: `${this.imgPath}/steps/special-1@3x.jpg`,
          title: this.$t("На главной странице")
        },
        {
          img: `${this.imgPath}/steps/special-2@3x.jpg`,
          title: this.$t("На странице библиотеки")
        },
        {
          img: `${this.imgPath}/steps/special-3@3x.jpg`,
          title: this.$t("На странице каталога производителей")
        },
      ],
      advantages: [
        {
          img: `${this.imgPath}/3.svg`,
          title: this.$t("Поможем выстроить эффективную стратегию коммуникации с профессиональным сообществом инженеров")
        },
        {
          img: `${this.imgPath}/4.svg`,
          title: this.$t("Соберем оптимальный пакет услуг")
        },
        {
          img: `${this.imgPath}/5.svg`,
          title: this.$t("Проанализируем ваши продукты")
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.luxury-color {
  color: $luxury-color;
}

.steps__title {
  max-width: 445px;
  margin-bottom: 48px;
}

.block-sale {
  padding: 100px 0 0;
  .block-sale__more {
    font-size: 16px;
    text-transform: uppercase;
  }
  .tariff__delimiter {
    margin: 40px 0 50px;
    height: 1px;
    border-top: 1px solid $white-color-600;
    width: 100%;
  }
}

.advantages {
  @media screen and (max-width: $breakpoint-lg) {
    flex-wrap: wrap;
  }
  .advantages__item {
    display: flex;
    align-items: flex-start;
    flex: 1 1 33.3333%;

    &:not(:last-child) {
      margin-right: 34px;
      @media screen and (max-width: $breakpoint-lg) {
        margin-right: 0;
        margin-bottom: 34px;
      }
    }

    @media screen and (max-width: $breakpoint-lg) {
      flex: 1 1 100%;
    }
  }

  .advantages__title {
    position: relative;
    top: 10px;
  }
}

.tariff {
  .tariff-price__wrapper {
    text-align: right;
  }
  .tariff-price__number {
    white-space: nowrap;
    font-size: 50px;
    line-height: 1.18;
  }
}
</style>
